import { t } from 'ttag'

export const getTraits = () => {
  const traits = [
    { label: t`Processing speed`, trait: 'GMA' },
    { label: t`Agreeableness`, trait: 'Agreeableness' },
    { label: t`Conscientiousness`, trait: 'Conscientiousness' },
    { label: t`Extraversion`, trait: 'Extraversion' },
    {
      label: t`Openness to experience`,
      trait: 'Openness to Experience',
    },
    { label: t`Emotional stability`, trait: 'Emotional Stability' },
  ]

  return traits
}
